<template>
  <tr>
    <td>{{ classError.teacher_name }} - {{ classError.teacher_id }}</td>
    <td>{{ classError.date | formatDate }}
      <br>
      {{ classError.start_time }} - {{ classError.end_time }}
    </td>
    <td>{{ classError.branch }}</td>
    <td>{{ classError.unit_price | formatVND }}</td>
    <td>
      <button class="btn btn-xs btn-outline-primary" @click="isEdit = true">
        <i class="el-icon-edit"></i>
      </button>
    </td>
    <el-dialog v-if="isEdit" :show-close="false" :visible.sync="isEdit" width="30%">
      <div slot="title" style="display: flex; width: 100%; justify-content: start">
        <h3>Thêm mới công</h3>
      </div>
      <hr style="margin-top: -35px"/>
      <WorkRecordForm
          :branches="branches"
          :time-sheet="classError"
          @closeDialog="closeDialog"
          @createSuccess="updateWorkAttendance"
      />
    </el-dialog>
  </tr>
</template>
<script>
import WorkRecordForm from "@/view/pages/classes/components/WorkRecordForm.vue";

export default {
  components: {WorkRecordForm},
  props: {
    classError: Object,
    branches: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      isEdit: false
    };
  },

  methods: {
    closeDialog() {
      this.isEdit = false;
    },
    updateWorkAttendance() {
      this.isEdit = false
      this.$emit('updateWorkAttendance');
    }
  }
}
</script>
